import { render, staticRenderFns } from "./191015disscussion.md?vue&type=template&id=9a051020&"
import script from "./191015disscussion.md?vue&type=script&lang=js&"
export * from "./191015disscussion.md?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports